import * as z from 'zod'
import { CustomerListItem, CustomerSingleItem, DCustomerListItem, DCustomerSingleItem } from '../CustomerEntity.js'
import { PaginatedResponse } from '../PaginatedResponse.js'
import { GetApiContract, PostApiContract, PutApiContract } from './ApiContract.js'

export interface GetCustomerByIdRequest extends GetApiContract {
    Response: DCustomerSingleItem
    ResponseJson: CustomerSingleItem
}

export const CUSTOMER_LIST_SORT_FIELDS = ['name', 'lastActive', 'userCount'] as const

export type CustomerListSortField = (typeof CUSTOMER_LIST_SORT_FIELDS)[number]

export const getCustomerListQuerySchema = z.object({
    page: z.coerce.number(),
    limit: z.coerce.number().max(100),
    search: z.string().optional(),
    sortField: z.enum(CUSTOMER_LIST_SORT_FIELDS).optional(),
    sortDirection: z.enum(['asc', 'desc']).optional(),
})

export type CustomerListQueryParameters = z.infer<typeof getCustomerListQuerySchema>

export interface GetCustomerListRequest extends GetApiContract {
    Response: PaginatedResponse<DCustomerListItem>
    ResponseJson: PaginatedResponse<CustomerListItem>
    QueryParameters: CustomerListQueryParameters
}

export const postCustomerSchema = z.object({
    name: z.string(),
})

export interface PostCustomerRequest extends PostApiContract {
    Body: z.infer<typeof postCustomerSchema>
    Response: Record<never, never>
    ResponseJson: Record<never, never>
}

export const putCustomerSchema = postCustomerSchema

export interface PutCustomerRequest extends PutApiContract {
    Body: z.infer<typeof putCustomerSchema>
    Response: Record<never, never>
    ResponseJson: Record<never, never>
}
